// @ts-nocheck
// tool-roas.js — ROAS Calculator behaviour (SSM-631).
//
// Math ported verbatim from the Vercel app's src/lib/roas.ts. Writes computed values
// into markup that snippets/tool-roas.liquid already rendered; it never builds DOM.
//
// The benchmark bands are read out of the server-rendered reference list rather than
// duplicated here, so the thresholds and wording live in exactly one place.
(function () {
  var roots = document.querySelectorAll('[data-tool="roas"]');
  if (!roots.length) return;

  // ── Math (src/lib/roas.ts) ────────────────────────────────────────────────
  var TARGET_MULTIPLE = 8; // 800% ROAS
  var PROGRESS_CAP = 1000; // bar maxes out at 1000% ROAS, so 800% sits at 80%

  function calcROAS(revenue, adSpend) {
    return adSpend > 0 ? (revenue / adSpend) * 100 : 0;
  }

  function calcTargetRevenue(adSpend) {
    return adSpend * TARGET_MULTIPLE;
  }

  // null margin means "not supplied", which is not the same as a zero margin.
  function calcROI(revenue, margin, adSpend) {
    return margin != null ? revenue * (margin / 100) - adSpend : null;
  }

  function calcProgressWidth(roas) {
    return Math.min(roas / PROGRESS_CAP, 1) * 100;
  }

  // ── Formatting ────────────────────────────────────────────────────────────
  function usd(n) {
    return n.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    });
  }

  // Parse to a non-negative number, or null when empty/invalid. Stripping every
  // non-numeric character means a minus sign can never reach Number(), so the result
  // is never negative.
  function parseNum(raw) {
    var cleaned = String(raw).replace(/[^0-9.]/g, '');
    if (cleaned === '') return null;
    var n = Number(cleaned);
    return isFinite(n) && n >= 0 ? n : null;
  }

  // Liquid indents the band copy, so collapse it before reusing it as result text.
  function tidy(node) {
    if (!node) return '';
    return node.textContent.replace(/\s+/g, ' ').trim();
  }

  function mount(root) {
    if (root.dataset.toolMounted) return;
    root.dataset.toolMounted = 'true';

    var inputs = {
      adSpend: root.querySelector('[data-roas-input="adSpend"]'),
      revenue: root.querySelector('[data-roas-input="revenue"]'),
      margin: root.querySelector('[data-roas-input="margin"]')
    };
    if (!inputs.adSpend) return;

    var dontKnow = root.querySelector('[data-roas-dontknow]');
    var revenueRow = root.querySelector('[data-roas-revenue-row]');
    var emptyRevenueHint = root.querySelector('[data-roas-empty-revenue]');

    var states = {
      empty: root.querySelector('[data-roas-state="empty"]'),
      target: root.querySelector('[data-roas-state="target"]'),
      score: root.querySelector('[data-roas-state="score"]')
    };

    var out = {};
    var outNodes = root.querySelectorAll('[data-roas-out]');
    for (var i = 0; i < outNodes.length; i++) {
      out[outNodes[i].getAttribute('data-roas-out')] = outNodes[i];
    }

    var roiBox = root.querySelector('[data-roas-roi]');

    // Bands read from the DOM, ordered by threshold. The entry with no data-roas-max
    // is the open-ended top band.
    var bands = [];
    var bandNodes = root.querySelectorAll('[data-roas-band]');
    for (var b = 0; b < bandNodes.length; b++) {
      var node = bandNodes[b];
      var rawMax = node.getAttribute('data-roas-max');
      bands.push({
        name: node.getAttribute('data-roas-band'),
        max: rawMax === null ? Infinity : Number(rawMax),
        headline: tidy(node.querySelector('.tool-roas__band-headline')),
        message: tidy(node.querySelector('.tool-roas__band-message'))
      });
    }
    if (!bands.length) return;
    bands.sort(function (x, y) {
      return x.max - y.max;
    });

    function bandFor(roas) {
      for (var k = 0; k < bands.length; k++) {
        if (roas < bands[k].max) return bands[k];
      }
      return bands[bands.length - 1];
    }

    function show(name) {
      Object.keys(states).forEach(function (key) {
        if (states[key]) states[key].hidden = key !== name;
      });
    }

    function render() {
      var adSpendNum = parseNum(inputs.adSpend.value);
      var revenueNum = inputs.revenue ? parseNum(inputs.revenue.value) : null;
      var marginNum = inputs.margin ? parseNum(inputs.margin.value) : null;
      var skipRevenue = !!(dontKnow && dontKnow.checked);

      if (revenueRow) revenueRow.hidden = skipRevenue;
      if (emptyRevenueHint) emptyRevenueHint.hidden = skipRevenue;

      var hasSpend = adSpendNum != null && adSpendNum > 0;

      if (!hasSpend) {
        show('empty');
        return;
      }

      if (skipRevenue) {
        if (out.targetSpend) out.targetSpend.textContent = usd(adSpendNum);
        if (out.targetRevenue) {
          out.targetRevenue.textContent = usd(calcTargetRevenue(adSpendNum));
        }
        show('target');
        return;
      }

      if (revenueNum == null) {
        show('empty');
        return;
      }

      var roas = calcROAS(revenueNum, adSpendNum);
      var band = bandFor(roas);

      if (out.chip) {
        out.chip.textContent = band.headline;
        out.chip.setAttribute('data-band', band.name);
      }
      if (out.roas) out.roas.textContent = Math.round(roas) + '%';
      if (out.message) out.message.textContent = band.message;
      if (out.progress) {
        out.progress.style.width = calcProgressWidth(roas) + '%';
        out.progress.setAttribute('data-band', band.name);
      }

      var roi = calcROI(revenueNum, marginNum, adSpendNum);
      if (roiBox) {
        roiBox.hidden = roi == null;
        if (roi != null && out.roi) {
          out.roi.textContent = usd(roi);
          out.roi.setAttribute('data-sign', roi < 0 ? 'negative' : 'positive');
        }
      }

      show('score');
    }

    Object.keys(inputs).forEach(function (key) {
      if (inputs[key]) inputs[key].addEventListener('input', render);
    });
    if (dontKnow) dontKnow.addEventListener('change', render);

    render();
  }

  // Marked only after a clean mount, so free-tools.liquid reveals its fallback table if setup throws.
  for (var r = 0; r < roots.length; r++) {
    mount(roots[r]);
    roots[r].setAttribute('data-tool-ready', '');
  }
})();
